import { styled } from '@mui/material';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';

export const LogicIcon = styled(CallSplitOutlinedIcon)`
  transform: rotate(180deg);
`;
